import { useNavigate, useParams } from "react-router-dom";
import useData from "../../../hooks/useData";
import useAuth from "../../../hooks/useAuth";
import { createAdminAgency, getBillingAgencyList } from "../../../api/admin/agencyReq";
import { getAdminNetworkList } from "../../../api/admin/networkReq";
import { getEnsembleList } from "../../../api/admin/ensembleReq";
import { useEffect, useRef, useState } from "react";
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import { getLegalFormList } from "../../../api/admin/legalFormListReq";
import { getActivityList } from "../../../api/admin/activityReq";
import {
    getCityListSuggestByName,
    getCityListSuggestByZip,
    getEstablishmentById, setEstablishmentInfos
} from "../../../api/admin/funedataReq";
import { getCountryList } from "../../../api/admin/addressReq";
import {
    checkPasswordMatch, checkRequiredFields,
    getErrorListFromValidation, normalizeZipCode,
    patternListChoices,
    removeErrorList,
    validateFormInput
} from "../../../helper/tools";
import { resolve } from "url";
import DateInput from "../../../components/common/input-layout/DateInput";

export default function FormNewAgency() {
    const {
        networkList, setNetworkList,
        ensembleList, setEnsembleList,
        billingAgencyList, setBillingAgencyList,
        legalFormList, setLegalFormList,
        activityList, setActivityList,
        selectedCity, setSelectedCity,
        countryList, setCountryList,
    } = useData();

    const [agencyActivities, setAgencyActivities] = useState([]);
    const [establishment, setEstablishment] = useState();
    const { auth } = useAuth();
    const token = auth.token;
    const { id } = useParams();
    const creds = process.env.REACT_APP_FUNEDATA_CREDS;
    const navigate = useNavigate();
    const [values, setValues] = useState();
    const [isValid, setIsValid] = useState();
    const [cities, setCities] = useState();
    const [agencyCity, setAgencyCity] = useState({});
    const [localCityInput, setLocalCityInput] = useState("");
    const [localZipInput, setLocalZipInput] = useState("");
    const selectCityRef = useRef()
    const [newAgencyId, setNewAgencyId] = useState();

    const today = new Date().toISOString().split('T')[0];

    const apiLegalFormList = async () => {
        const response = await getLegalFormList(token);
        setLegalFormList(response);
    };

    const apiCountryList = async () => {
        const response = await getCountryList(token);
        setCountryList(response);
    }

    const apiActivityList = async () => {
        const response = await getActivityList(token);
        setActivityList(response);
    }

    const apiNetworkList = async () => {
        const response = await getAdminNetworkList(token, 0, 0)
        setNetworkList(response?.networkList)
    };

    const apiEnsembleList = async () => {
        const response = await getEnsembleList(token)
        setEnsembleList(response)
    };

    const apiBillingAgencyList = async () => {
        const response = await getBillingAgencyList(token)
        setBillingAgencyList(response)
    };

    const handleAdd = (id, name) => {
        if (!agencyActivities?.find(activity => activity?.id === id)) {
            setAgencyActivities([...agencyActivities, { id, name }])
        }
    }

    const handleDelete = (id) => {
        setAgencyActivities(agencyActivities?.filter(activity => activity?.id !== id))
    }


    const apiCityListAllByName = async (keyword) => {
        let body = {
            creds: creds,
            keyword: keyword
        }
        const response = await getCityListSuggestByName(body, token);
        setCities(response);
    };

    const apiCityListAllByZip = async (keyword) => {
        let body = {
            creds: creds,
            keyword: keyword
        }
        const response = await getCityListSuggestByZip(body, token);
        setCities(response);
    };

    const apiEstablishmentInfos = async (establishmentData) => {
        return await setEstablishmentInfos(establishmentData, token)
    }
    const apiEstablishment = async (id) => {
        let body = {
            id: id,
            creds: creds
        }
        const response = await getEstablishmentById(body, token);
        setEstablishment(response)
    }

    const optionCountryList = countryList?.map(country => (
        { [country?.code]: [country?.name] }
    ));

    const handleChangeSearch = (e) => {
        let keyword = e.target.value;
        setLocalCityInput(keyword);

        if (keyword.length > 1 && typeof (keyword) === "string") {
            apiCityListAllByName(keyword);
        }
    }

    const handleZipCodeChange = (e) => {
        let keyword = e.target.value;
        setLocalZipInput(keyword);

        if (keyword.length > 1) {
            apiCityListAllByZip(keyword);
        }
    }

    const handleChangeSelected = () => {
        const selectedData = cities?.filter(city => city?.id == selectCityRef.current.value)[0];

        if (!selectedData) return;

        setAgencyCity(selectedData);

        setLocalCityInput(selectedData?.name || "");
        setLocalZipInput(selectedData?.zip || "");
    }

    useEffect(() => {
        apiEstablishment(id)
    }, [id]);


    const zipRef = useRef();
    const cityRef = useRef();
    const latitudeRef = useRef();
    const longitudeRef = useRef();
    const emailCondoRef = useRef();
    const phoneRef = useRef();
    const faxNumberRef = useRef();
    const emailRef = useRef();
    const urlRef = useRef();
    const streetNumRef = useRef();
    const streetExtensionRef = useRef();
    const streetTypeRef = useRef();
    const streetNameRef = useRef();
    const addressCompRef = useRef();
    const tvaNumber = useRef();
    const siretRef = useRef();
    const registrationDateRef = useRef();
    const authorizationCodeRef = useRef();
    const nameRef = useRef();
    const countryRef = useRef();
    const network = useRef();
    const ensemble = useRef();
    const hasBillingEmail = useRef();
    const managerPassword = useRef();
    const managerconfirmPassword = useRef();
    const managerEmailRef = useRef();
    const managerUsernameRef = useRef();
    const managerFirstNameRef = useRef();
    const managerLastNameRef = useRef();
    const managerOccupationRef = useRef();
    const managerFixedPhoneNumberRef = useRef();
    const managerMobilePhoneNumberRef = useRef();
    const managerCivilityRef = useRef();
    const morningStartRef = useRef();
    const morningEndRef = useRef();
    const afternoonStartRef = useRef();
    const afternoonEndRef = useRef();
    const fullAddressRef = useRef();

    const establishmentFullAddress = `${establishment?.streetNum}${establishment?.streetExtension != null ? establishment?.streetExtension : ""}, ${establishment?.streetType} ${establishment?.streetName}`;
    const fullAddressNew = fullAddressRef?.current?.value;
    let fullAddress = `${streetNumRef?.current?.value}${streetExtensionRef?.current?.value != null ? streetExtensionRef?.current?.value : ""}, ${streetTypeRef?.current?.value} ${streetNameRef?.current?.value}`;

    useEffect(() => {
        apiNetworkList()
        apiEnsembleList()
        apiBillingAgencyList()
        apiLegalFormList()
        apiActivityList()
        apiCountryList()
        return () => {
        }
    }, []);

    const cleanPhone = phoneRef?.current?.value?.replaceAll(" ", "");

    const onChangeMainInfos = (e) => {
        setValues({ ...values, main: { ...values?.main, [e.target.name]: e.target.value } })
        if (e.target.type === "checkbox") {
            setValues({ ...values, main: { ...values?.main, [e.target.name]: e.target.checked } })
        }
        validateFormInput(e);
    }

    const onChangeHoursInfos = (e) => {
        let { name, value } = e.target;
        const numbers = value.replace(/\D/g, "");
        let formattedValue = "";
        if (numbers.length > 0) {
            const limited = numbers.slice(0, 4);
            if (limited.length <= 2) {
                formattedValue = limited;
            } else {
                formattedValue = limited.slice(0, 2) + ":" + limited.slice(2);
            }
        }

        e.target.value = formattedValue;

        setValues(prev => ({
            ...prev,
            hours: {
                ...prev?.hours,
                [name]: formattedValue
            }
        }));
        validateFormInput(e);
    }

    const onChangeContactInfos = (e) => {
        setValues({ ...values, contact: { ...values?.contact, [e.target.name]: e.target.value } })
        if (e.target.type === "checkbox") {
            setValues({ ...values, contact: { ...values?.contact, [e.target.name]: e.target.checked } })
        }
        validateFormInput(e);
    }

    const onChangeManagerInfos = (e) => {
        setValues({ ...values, manager: { ...values?.manager, [e.target.name]: e.target.value } })
        if (e.target.type === "checkbox") {
            setValues({ ...values, manager: { ...values?.manager, [e.target.name]: e.target.checked } })
        }
        if (e.target.name !== "manager_password" && e.target.name !== "manager_confirm") {
            validateFormInput(e);
        }
    }

    useEffect(() => {
        if (checkPasswordMatch(managerPassword?.current?.value, managerconfirmPassword?.current?.value)) {
            setIsValid(true)
        } else {
            setIsValid(false)
        }
    }, [managerPassword?.current?.value, managerconfirmPassword?.current?.value])

    const onChangeInvoiceInfos = (e) => {
        setValues({ ...values, invoice: { ...values?.invoice, [e.target.name]: e.target.value } })
        if (e.target.type === "checkbox") {
            setValues({ ...values, invoice: { ...values?.invoice, [e.target.name]: e.target.checked } })
        }
        validateFormInput(e);
    }

    useEffect(() => {
        if (newAgencyId) {
            navigate(`/admin/agences/${newAgencyId}/voir`)
        }
    }, [newAgencyId]);

    const apiAdminCreateAgency = async (agencyBody) => {
        const response = await createAdminAgency(token, agencyBody)
        setNewAgencyId(response?.agencyId)
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!checkRequiredFields() || values?.main?.siteId == "") {
            return;
        }
        let activitiesData = [];
        agencyActivities?.map(activity => (
            activitiesData.push(activity.id)
        ))
        let addressInfos;
        if (id == 0) {
            addressInfos = fullAddressNew;
        } else if (establishmentFullAddress) {
            addressInfos = establishmentFullAddress;
        } else {
            addressInfos = fullAddress;
        }
        // Construit la chaîne des horaires stockée sur l'agence (champ texte unique), à partir
        // des 4 champs saisis séparément - sinon les horaires ne sont jamais enregistrées
        // localement (seule la synchronisation Funedata, via establishmentData, les récupérait).
        const hoursParts = [];
        if (morningStartRef?.current?.value || morningEndRef?.current?.value) {
            hoursParts.push(`Le matin de ${morningStartRef?.current?.value || ""} à ${morningEndRef?.current?.value || ""}`);
        }
        if (afternoonStartRef?.current?.value || afternoonEndRef?.current?.value) {
            hoursParts.push(`L'après-midi de ${afternoonStartRef?.current?.value || ""} à ${afternoonEndRef?.current?.value || ""}`);
        }
        const hoursString = hoursParts.join(" - ");
        const agencyBody = {
            creds: creds,
            agencyId: 0,
            estabId: id || 0,
            addressData: {
                address: addressInfos,
                addressComp: addressCompRef?.current?.value,
                city: cityRef?.current?.innerText,
                zipcode: zipRef?.current?.innerText,
                country: countryRef?.current?.value,
                latitude: latitudeRef?.current?.value,
                longitude: longitudeRef?.current?.value,
            },
            managerData: {
                managerEmail: managerEmailRef?.current?.value,
                username: managerUsernameRef?.current?.value,
                firstName: managerFirstNameRef?.current?.value,
                lastName: managerLastNameRef?.current?.value,
                civility: managerCivilityRef?.current?.value,
                occupation: managerOccupationRef?.current?.value,
                fixedPhoneNumber: (managerFixedPhoneNumberRef?.current?.value).replaceAll(" ", ""),
                mobilePhoneNumber: managerMobilePhoneNumberRef?.current?.value,
                password: values?.manager?.password,
                passwordConfirm: values?.manager?.passwordConfirm,
            },
            billingData: {
                billing: values?.invoice?.billing || false,
                flateRate: values?.invoice?.flateRate || false,
                billingAgency: values?.invoice?.billingAgency,
                invoiceNumber: values?.invoice?.invoiceNumber,
                contractReference: values?.invoice?.contractReference,
                deceasedNumber: parseInt(values?.invoice?.deceasedNumber),
                deceasedPrice: values?.invoice?.deceasedPrice,
                deceasedReduct: values?.invoice?.deceasedReduct,
                linkWebsite: values?.invoice?.linkWebsite || false,
                templateNumber: parseInt(values?.invoice?.templateNumber),
                templatePrice: values?.invoice?.templatePrice,
                templateReduct: values?.invoice?.templateReduct,
                hasBillingEmail: values?.invoice?.hasBillingEmail || false,
                billingEmail: values?.invoice?.billingEmail,
                oriasNum: values?.invoice?.oriasNum,
            },
            generalData: {
                siteId: values?.main?.siteId,
                name: nameRef?.current?.value,
                headquarters: values?.main?.headquarters || false,
                isEnsemble: values?.main?.isEnsemble || false,
                ensembleId: values?.main?.ensembleId || 0,
                networkId: values?.main?.networkId || 0,
                legalFormId: values?.main?.legalForm || 0,
                authorizationCode: authorizationCodeRef?.current?.value,
                registrationDate: registrationDateRef?.current?.value,
                siret: siretRef?.current?.value,
                tvaNumber: tvaNumber?.current?.value,
                capital: parseInt(values?.main?.capital),
                workforce: parseInt(values?.main?.workforce),
                orias: values?.invoice?.oriasNum,
                hours: hoursString,
            },
            contactData: {
                additionalZipcodes: values?.contact?.zipcodes,
                phone: (phoneRef?.current?.value).replaceAll(" ", ""),
                email: emailRef?.current?.value,
                website: urlRef?.current?.value,
                hasCondolenceEmail: values?.contact?.hasCondolenceEmail || false,
                condolenceEmail: emailCondoRef?.current?.value
            },
            activities: activitiesData,
            establishmentData: {
                creds: creds,
                estabId: id,
                name: values?.main?.name,
                contact_email: values?.manager?.managerEmail,
                latitude: values?.contact?.latitude,
                longitude: values?.contact?.longitude,
                contact_firstname: managerFirstNameRef?.current?.value,
                contact_lastname: managerLastNameRef?.current?.value,
                contact_title: managerCivilityRef?.current?.value,
                mobile: managerMobilePhoneNumberRef?.current?.value,
                streetNum: streetNumRef?.current?.value ? streetNumRef?.current?.value : establishment?.streetNum,
                streetExtension: streetExtensionRef?.current?.value ? streetExtensionRef?.current?.value : establishment?.streetExtension,
                streetType: streetTypeRef?.current?.value ? streetTypeRef?.current?.value : establishment?.streetType,
                streetName: streetNameRef?.current?.value ? streetNameRef?.current?.value : establishment?.streetName,
                addressComp: values?.contact?.addressComp,
                city: cityRef?.current?.innerText,
                zipcode: normalizeZipCode(zipRef?.current?.innerText),
                authorization_code: values?.main?.authorizationCode,
                email: values?.contact?.email,
                fax: faxNumberRef?.current?.value,
                hours: {
                    morning_start: morningStartRef?.current?.value,
                    morning_end: morningEndRef?.current?.value,
                    afternoon_start: afternoonStartRef?.current?.value,
                    afternoon_end: afternoonEndRef?.current?.value,
                },
                oriasNum: values?.invoice?.oriasNum || "",
                siren: values?.main?.siret,
                url_site: values?.contact?.website,
            }
        }

        const response = await apiAdminCreateAgency(agencyBody)
    }

    return (
        <main>
            <Header
                parent="Agences"
                location="Ajout d'une agence"
                slug="/admin/agences"
            />
            <div className="new-agency">
                <form method="POST" onSubmit={handleSubmit}>
                    <div className="flex double-fieldset documents">
                        <fieldset>
                            <Icon source="fa fa-building" span="Informations générales"/>
                            <div className="form-input">
                                <label htmlFor="name" className="required">Nom</label>
                                <input pattern={patternListChoices?.agencyName} ref={nameRef} required={true} type="text" name="name" defaultValue={id != 0 ? establishment?.name : ""} onChange={onChangeMainInfos} />
                            </div>
                            <div className="form-input">
                                <label>Siège social</label>
                                <input type="checkbox" name="headquarters" onChange={onChangeMainInfos} />
                            </div>
                            <div className="form-input">
                                <label>Ensemble</label>
                                <input type="checkbox" name="isEnsemble" onChange={onChangeMainInfos} />
                            </div>

                            <div className="form-input">
                                <label>Forme juridique</label>
                                <select name="legalForm" onChange={onChangeMainInfos}>
                                    <option name="legalForm" selected="selected" value={0}>Sélectionnez une forme juridique</option>
                                    {legalFormList?.map(legalForm => (
                                        <option name="legalForm" key={legalForm?.id} value={legalForm?.id}>{legalForm?.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-input">
                                <label>Code d'habilitation</label>
                                <input ref={authorizationCodeRef} defaultValue={establishment?.authorizationCode} pattern={patternListChoices?.alphaNum} type="text" name="authorizationCode" onChange={onChangeMainInfos} />
                            </div>
                            <div className="form-input">
                                <label>Date d'immatriculation</label>
                                <DateInput ref={registrationDateRef} max="9999-12-31" name="registrationDate" defaultValue={today} onChange={onChangeMainInfos} />
                            </div>
                            <div className="form-input">
                                <label>Siret</label>
                                <input ref={siretRef} defaultValue={establishment?.siren} pattern={patternListChoices?.siret} type="text" name="siret" onBlur={onChangeMainInfos} />
                            </div>
                            <div className="form-input">
                                <label>Numéro ORIAS</label>
                                <input type="text" name="oriasNum" onChange={onChangeInvoiceInfos} />
                            </div>
                            <div className="form-input">
                                <label>TVA intracommunautaire</label>
                                <input ref={tvaNumber} pattern={patternListChoices?.tvaIntra} type="text" name="tvaNumber" onChange={onChangeMainInfos} />
                            </div>
                            <div className="form-input">
                                <label>Capital</label>
                                <input pattern={patternListChoices?.num} type="text" name="capital" onChange={onChangeMainInfos} />
                            </div>
                            <div className="form-input">
                                <label>Effectif</label>
                                <input pattern={patternListChoices?.num} type="text" name="workforce" onChange={onChangeMainInfos} />
                            </div>
                            <div className="form-input">
                                <label><b>Horaires</b> - Le matin de </label>
                                <input ref={morningStartRef} defaultValue={establishment?.hours?.morning_start} type="text" name="morning_start" onChange={onChangeHoursInfos} maxLength={5} placeholder="00:00" />
                            </div>
                            <div className="form-input">
                                <label>à </label>
                                <input ref={morningEndRef} defaultValue={establishment?.hours?.morning_end} type="text" name="morning_end" onChange={onChangeHoursInfos} maxLength={5} placeholder="00:00" />
                            </div>
                            <div className="form-input">
                                <label>L'après-midi de </label>
                                <input ref={afternoonStartRef} defaultValue={establishment?.hours?.afternoon_start} type="text" name="afternoon_start" onChange={onChangeHoursInfos} maxLength={5} placeholder="00:00" />
                            </div>
                            <div className="form-input">
                                <label>à </label>
                                <input ref={afternoonEndRef} defaultValue={establishment?.hours?.afternoon_end} type="text" name="afternoon_end" onChange={onChangeHoursInfos} maxLength={5} placeholder="00:00" />
                            </div>
                            <div className="form-input">
                                <div>
                                    <div className="form-activities">
                                        <label>Ajouter une activité</label>
                                        <div className="agency-activities">
                                            <div className="flex">
                                                {activityList?.filter(activity => activity?.activityEnabled)?.map(activity => (
                                                    <span key={activity?.id}
                                                        onClick={() => handleAdd(activity?.id, activity?.name)}>
                                                        <i className="fa fa-plus"></i>
                                                        {activity?.name}</span>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="agency-activities-selected">
                                            {agencyActivities?.map(activity => (
                                                <span key={activity?.id} id={activity?.id}>{activity?.name}<i
                                                    onClick={() => handleDelete(activity?.id)}
                                                    className="fa fa-trash"></i></span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset>
                            <Icon source="fa fa-address-book" span="Contacts - Codes postaux"/>
                            {id == 0 ?
                                <>
                                    <div className="form-input">
                                        <label htmlFor="streetNum">Numéro de rue</label>
                                        <input ref={streetNumRef} pattern={patternListChoices?.num} required={false}
                                            type="text" name="streetNum" onChange={onChangeContactInfos} />
                                    </div>
                                    <div className="form-input">
                                        <label htmlFor="streetExtension">Extension de rue (bis, ter, ...)</label>
                                        <input ref={streetExtensionRef} type="text" name="streetExtension" required={false}
                                            onChange={onChangeContactInfos} />
                                    </div>
                                    <div className="form-input">
                                        <label htmlFor="streetType">Type de voie (rue, route, ...)</label>
                                        <input ref={streetTypeRef} pattern={patternListChoices?.streetType}
                                            required={false} type="text" name="streetType"
                                            onChange={onChangeContactInfos} />
                                    </div>
                                    <div className="form-input">
                                        <label htmlFor="streetName" className="required">Nom de rue</label>
                                        <input ref={streetNameRef} pattern={patternListChoices?.address}
                                            required={true} type="text" name="streetName"
                                            onChange={onChangeContactInfos} />
                                    </div>
                                </> :
                                <div className="form-input">
                                    <label ref={fullAddressRef} htmlFor="address" className="required">Adresse postale</label>
                                    <input pattern={patternListChoices?.address} required={true} type="text"
                                        name="address"
                                        defaultValue={establishment && establishmentFullAddress}
                                        onChange={onChangeContactInfos} />
                                </div>
                            }
                            <div className="form-input">
                                <label>Complément d'adresse</label>
                                <input ref={addressCompRef} pattern={patternListChoices?.address} type="text"
                                    name="addressComp"
                                    defaultValue={establishment?.addressComp} onChange={onChangeContactInfos} />
                            </div>
                            {establishment?.city && establishment?.zipcode
                                ? <div className="flex city-span">
                                    <div className="form-input">
                                        <label className="required"><b>Code postal </b></label><span
                                            ref={zipRef}>{establishment?.zipcode}</span>
                                    </div>
                                    <label className="required"><b>Ville </b></label><span
                                        ref={cityRef}>{establishment?.city}</span>
                                </div>
                                : selectedCity?.name && selectedCity?.zipcode ?
                                    <>
                                        <div className="flex city-span">
                                            <div className="form-input">
                                                <label><b>Code postal </b></label><span
                                                    ref={zipRef}>{selectedCity?.zipcode}</span>
                                            </div>
                                            <label><b>Ville </b></label><span ref={cityRef}>{selectedCity?.name}</span>
                                        </div>
                                    </>
                                    : ""
                            }
                            {selectedCity?.name == null &&
                                selectedCity?.zipcode == null &&
                                establishment?.city == null &&
                                establishment?.zipcode == null &&
                                <>
                                    <div className="form-input">
                                        <label>Recherche par code postal</label>
                                        <input
                                            pattern={patternListChoices?.zip}
                                            onChange={handleZipCodeChange}
                                            value={localZipInput}
                                            type="text"
                                            name="zipcode"
                                        />
                                    </div>
                                    <div className="form-input">
                                        <label>Recherche par ville</label>
                                        <input
                                            pattern={patternListChoices?.city}
                                            onChange={handleChangeSearch}
                                            value={localCityInput}
                                            type="text"
                                            name="city"
                                        />
                                    </div>
                                    <p className="description">L'un ou l'autre est obligatoire.</p>
                                    {cities &&
                                        <div className="form-input" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <select onChange={handleChangeSelected} ref={selectCityRef} id="city-select"
                                                name="city" style={{ flex: '0 0 auto' }}>
                                                {cities?.map((city, index) => (
                                                    <option name="city" key={index}
                                                        value={city?.id}>{city?.city_zip}</option>
                                                ))}
                                            </select>
                                            <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <label className="required" style={{ marginLeft: '15px' }}><b>Code postal : </b></label>
                                                <span ref={zipRef}>{agencyCity?.zip}</span>
                                                <label className="required"><b>Ville : </b></label>
                                                <span ref={cityRef}>{agencyCity?.name}</span>
                                            </span>
                                        </div>
                                    }
                                </>
                            }
                            <div className="form-input">
                                <label className="required">Pays</label>
                                <select ref={countryRef} required={true} name="country"
                                    defaultValue={establishment?.country}
                                    onChange={onChangeContactInfos}>
                                    <option defaultValue="FR" name="country" value="FR" selected="selected">France
                                    </option>
                                    {optionCountryList.map((option) => (
                                        <option
                                            key={`option` + (Object.keys(option))}
                                            value={Object.keys(option)}
                                            name={Object.values(option)}
                                        >{Object.values(option)}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-input">
                                <label className="required">Latitude</label>
                                <input ref={latitudeRef} pattern={patternListChoices?.latitude} required={true}
                                    type="text" name="latitude"
                                    defaultValue={establishment?.latitude} onChange={onChangeContactInfos} />
                            </div>
                            <div className="form-input">
                                <label className="required">Longitude</label>
                                <input ref={longitudeRef} pattern={patternListChoices?.longitude} required={true}
                                    type="text" name="longitude"
                                    defaultValue={establishment?.longitude} onChange={onChangeContactInfos} />
                            </div>
                            <div className="form-input">
                                <label>Codes postaux additionnels (séparés par une virgule)</label>
                                <textarea name="zipcodes" onChange={onChangeContactInfos}></textarea>
                            </div>
                            <div className="form-input">
                                <label>Téléphone</label>
                                <input ref={phoneRef} pattern={patternListChoices?.phone} type="text" name="phone"
                                    defaultValue={establishment?.phone} onChange={onChangeContactInfos} />
                            </div>
                            <div className="form-input">
                                <label>Fax</label>
                                <input ref={faxNumberRef} type="text" name="fax"
                                    defaultValue={establishment?.fax} onChange={onChangeContactInfos} />
                            </div>
                            <div className="form-input">
                                <label className="required">Email</label>
                                <input ref={emailRef} required={true} type="email" name="email"
                                    defaultValue={establishment?.email} onChange={onChangeContactInfos} />
                            </div>
                            <div className="form-input">
                                <label>Site Internet</label>
                                <input ref={urlRef} pattern={patternListChoices?.url} type="text" name="website"
                                    defaultValue={establishment?.url_site} onChange={onChangeContactInfos} />
                            </div>
                            <div className="form-input">
                                <label>A un email de condoléances</label>
                                <input type="checkbox" name="hasCondolenceEmail" onChange={onChangeContactInfos} />
                            </div>
                            {values?.contact?.hasCondolenceEmail &&
                                <div className="form-input">
                                    <label>Email de condoléances</label>
                                    <input ref={emailCondoRef} type="email" name="condolenceEmail"
                                        onChange={onChangeContactInfos} />
                                </div>
                            }
                        </fieldset>
                    </div>
                    <div className="flex double-fieldset">
                        <fieldset>
                            <Icon source="fa fa-globe" span="Informations Site Internet"/>
                            <div className="form-input">
                                <label className="required">Solution Multi Services</label>
                                <select name="siteId" onChange={onChangeMainInfos} required>
                                    <option name="siteId" selected="selected" value="" disabled>Sélectionnez une solution</option>
                                    <option value="1" name="siteId">SMS</option>
                                    <option value="2" name="siteId">Annuaire</option>
                                    <option value="3" name="siteId">eSMS</option>
                                    <option value="4" name="siteId">Non visible</option>
                                    <option value="5" name="siteId">Comparateur</option>
                                </select>
                            </div>
                        </fieldset>
                        <fieldset>
                            <Icon source="fa fa-sitemap" span="Relations de l'agence"/>
                            <div className="form-input">
                                <label>Réseau de l'agence</label>
                                <select ref={network} name="networkId" onChange={onChangeMainInfos}>
                                    <option name="network" selected="selected">Sélectionnez un réseau</option>
                                    {networkList?.map((network, index) => (
                                        <option name="networkId" key={index} value={network?.id}>{network?.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-input">
                                <label>Ensemble de l'agence</label>
                                <select ref={ensemble} name="ensembleId" onChange={onChangeMainInfos}>
                                    <option name="ensembleId" selected="selected">Sélectionnez un ensemble</option>
                                    {ensembleList?.map(ensemble => (
                                        <option name="ensembleId" key={ensemble?.id} value={ensemble?.id}>{ensemble?.name}</option>
                                    ))}
                                </select>
                            </div>
                        </fieldset>
                    </div>
                    <div className="flex double-fieldset">
                        <fieldset>
                            <Icon source="fa fa-user-tie" span="Responsable de l'agence"/>
                            <div className="form-input">
                                <label className="required">Email</label>
                                <input ref={managerEmailRef} type="email" name="managerEmail" required
                                    defaultValue={establishment?.contact_email} onChange={onChangeManagerInfos} />
                            </div>
                            <div className="form-input">
                                <label>Civilité</label>
                                <select name="managerTitle" onChange={onChangeManagerInfos}>
                                    <option name="managerTitle" selected="selected">Sélectionnez une civilité</option>
                                    <option ref={managerCivilityRef} selected={establishment?.contact_title === "M"} name="managerTitle" value="M">Monsieur</option>
                                    <option selected={establishment?.contact_title === "MME"} name="managerTitle" value="MME">Madame</option>
                                </select>
                            </div>
                            <div className="form-input">
                                <label>Nom</label>
                                <input ref={managerLastNameRef} type="text" name="managerLastName"
                                    defaultValue={establishment?.contact_lastname} onChange={onChangeManagerInfos} />
                            </div>
                            <div className="form-input">
                                <label>Prénom</label>
                                <input ref={managerFirstNameRef} type="text" name="managerFirstName"
                                    defaultValue={establishment?.contact_firstname} onChange={onChangeManagerInfos} />
                            </div>
                            <div className="form-input">
                                <label className="required">Identifiant</label>
                                <input ref={managerUsernameRef} required={true} type="text" name="username" onChange={onChangeManagerInfos} />
                            </div>
                            <div className="form-input">
                                <label>Fonction</label>
                                <input ref={managerOccupationRef} type="text" name="occupation" onChange={onChangeManagerInfos} />
                            </div>
                            <div className="form-input">
                                <label>Téléphone fixe</label>
                                <input ref={managerFixedPhoneNumberRef} type="text" name="fixedPhoneNumber" defaultValue={establishment?.phone} onChange={onChangeManagerInfos} />
                            </div>
                            <div className="form-input">
                                <label>Téléphone mobile</label>
                                <input ref={managerMobilePhoneNumberRef} type="text" name="mobilePhoneNumber" defaultValue={establishment?.mobile} onChange={onChangeManagerInfos} />
                            </div>
                            <div className={`form-input ${isValid == true ? "valid" : isValid == false ? "invalid" : ""}`}>
                                <label className="required">Mot de passe</label>
                                <input placeholder="Mot de passe" defaultValue="" pattern={patternListChoices?.password} ref={managerPassword} required type="password" name="password" onChange={onChangeManagerInfos} />
                            </div>
                            <div className={`form-input ${isValid == true ? "valid" : isValid == false ? "invalid" : ""}`}>
                                <label className="required">Confirm. MDP</label>
                                <input placeholder="Corfirmation du mot de passe" pattern={patternListChoices?.password} ref={managerconfirmPassword} required type="password" name="passwordConfirm" onChange={onChangeManagerInfos} />
                            </div>
                        </fieldset>
                        <fieldset>
                            <Icon source="fa fa-file-invoice-dollar" span="Facturation"/>
                            <div className="form-input">
                                <label>Facturation</label>
                                <input type="checkbox" name="billing" onChange={onChangeInvoiceInfos} />
                            </div>
                            <div className="form-input">
                                <label>Au forfait</label>
                                <input type="checkbox" name="flateRate" onChange={onChangeInvoiceInfos} />
                            </div>
                            <div className="form-input">
                                <label>Agence de facturation</label>
                                <select name="billingAgency" onChange={onChangeInvoiceInfos}>
                                    <option name="billingAgency" selected="selected" disabled="disabled">Sélectionnez une agence</option>
                                    {billingAgencyList?.map(billingAgency => (
                                        <option name="billingAgency" key={billingAgency?.id}
                                            value={billingAgency.id}>{billingAgency?.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-input">
                                <label>Numéro de facture</label>
                                <input type="text" name="invoiceNumber" onChange={onChangeInvoiceInfos} />
                            </div>
                            <div className="form-input">
                                <label>Référence contrat OEF</label>
                                <input type="text" name="contractReference" onChange={onChangeInvoiceInfos} />
                            </div>
                            <div className="form-input">
                                <label>Nombre de défunts</label>
                                <input type="number" name="deceasedNumber" onChange={onChangeInvoiceInfos} />
                            </div>
                            <div className="form-input">
                                <label>Site partenaire</label>
                                <input type="checkbox" name="linkWebsite" onChange={onChangeInvoiceInfos} />
                            </div>
                            <div className="form-input">
                                <label>Prix défunt unitaire (H.T.)</label>
                                <input type="number" name="deceasedPrice" onChange={onChangeInvoiceInfos} />
                            </div>
                            <div className="form-input">
                                <label>Nombre de sites</label>
                                <input type="number" name="templateNumber" onChange={onChangeInvoiceInfos} />
                            </div>
                            <div className="form-input">
                                <label>Réduction accordée pour les défunts (%)</label>
                                <input type="number" name="deceasedReduct" onChange={onChangeInvoiceInfos} />
                            </div>
                            <div className="form-input">
                                <label>Prix site unitaire (H.T.)</label>
                                <input type="number" name="templatePrice" onChange={onChangeInvoiceInfos} />
                            </div>
                            <div className="form-input">
                                <label>Réduction accordée pour les sites (€)</label>
                                <input type="number" name="templateReduct" onChange={onChangeInvoiceInfos} />
                            </div>
                            <div className="form-input">
                                <label>A un email de facturation</label>
                                <input ref={hasBillingEmail} type="checkbox" name="hasBillingEmail" onChange={onChangeInvoiceInfos} />
                            </div>
                            {hasBillingEmail?.current?.checked ?
                                <div className="form-input">
                                    <label>Email de facturation</label>
                                    <input type="email" name="billingEmail" onChange={onChangeInvoiceInfos} />
                                </div>
                                : ""
                            }
                        </fieldset>
                    </div>
                    <div className="cms-button">
                        <button onClick={() => navigate(-1)} className="red-button">
                            <i className="fa fa-xmark"></i>
                            <span>Annuler</span>
                        </button>
                        <button className="green-button" type="submit">
                            <i className="fa fa-check"></i>
                            <span>Enregistrer</span>
                        </button>
                    </div>
                </form>
            </div>
            <div className="errors"></div>
        </main>
    )
}
